import { configureStore } from '@reduxjs/toolkit';

import { api } from './api/base';
import './api/cache-tags';
import authMiddleware from './middleware/auth.middleware';
import certificateMiddleware from './middleware/certificate.middleware';
import rehydrateStore from './middleware/rehydrate-store';
import { rootReducer } from './rootReducer';

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: rehydrateStore(),
  devTools: process.env.NODE_ENV === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authMiddleware,
      certificateMiddleware,
      api.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
// export const useAppDispatch: () => AppDispatch = useDispatch;
// export const useAppSelector = createSelectorHook<RootState>()

export type AppDispatch = typeof store.dispatch;
